export const POST16_ATTENDANCE_ENABLED = true ;
export const FIRST_POST16_ATTENDANCE_YEAR = 2026 ;

export const UserTypes = {
    SYSTEM_ADMIN: 1,
    TEAM_LEAD : 2,
    ESW : 3,
    PERSONAL_ASSISTANT : 4,
    DESI_TEACHER : 5,
    VIRTUAL_SCHOOL_HEAD : 6,
    AUTHORITY_MANAGER : 7,
    LAC : 8,
    SOCIAL_WORKER : 9,
    CARER : 10,
    PERFORMANCE_AND_DEVELOPMENT : 11,
    EDUCATIONAL_PSYCHOLOGIST : 12,
    IRO : 13,
    ATTENDANCE_OFFICER : 14,
    CAREERS_ADVISOR: 15,
    EWS_OFFICER: 16,
    LEAD_CAREERS_ADVISOR: 17,
    EHCP_COORDINATOR: 18,
    DEFAULT: 999,
    ALL: 999,
};

export const LOGIN_USERS = [
    UserTypes.DESI_TEACHER, UserTypes.ATTENDANCE_OFFICER,UserTypes.LEAD_CAREERS_ADVISOR,
    UserTypes.PERFORMANCE_AND_DEVELOPMENT, UserTypes.VIRTUAL_SCHOOL_HEAD,
    UserTypes.TEAM_LEAD, UserTypes.SYSTEM_ADMIN, UserTypes.ESW, UserTypes.EWS_OFFICER,
    UserTypes.EDUCATIONAL_PSYCHOLOGIST ] ;

export const PepStatus = {
    IN_PROGRESS: 1,
    AWAITING_FOLLOWUP : 2,
    COMPLETED : 3,
    AWAITING_REVIEW : 4,
    REJECTED : 5,
    RESUBMITTED : 6,
    PENDING_FURTHER_ACTION : 7,
    TIMED_OUT : 8,
    AWAITING_ESW_REVIEW : 9,
    CREATING: 10
};

export const PepDelegateStatus = {
    ASSIGNED: 1,
    RETURNED : 2,
    CANCELLED : 3,
    CLOSED: 4
}

export const PepGroups = {
    PRE_16: 11,
    POST_16: 12,
}

/**
 * These are the only valid modal modes which can be passed into ModalPanelChild
 *
 * @readonly
 * @enum {EducationStatusTypes}
 */
export const EducationStatusTypes = {
    EET: 1,
    NEET: 2,
    UNKNOWN: 3,
    ALL: 99
}

/**
 * These are the only valid modal modes which can be passed into ModalPanelChild
 *
 * @readonly
 * @enum {EducationStatusFilter}
 */
export const EducationStatusFilter = {
    ALL: 0,
    SEND: 1,
    EHCP: 2
}

export const PupilViewDataTypes = {
    STAR_RATING: 6,
}
